import { render, staticRenderFns } from "./addView.vue?vue&type=template&id=47ac4992&scoped=true"
import script from "./addView.vue?vue&type=script&lang=js"
export * from "./addView.vue?vue&type=script&lang=js"
import style0 from "./addView.vue?vue&type=style&index=0&id=47ac4992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ac4992",
  null
  
)

export default component.exports